import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const userChapters = state.chapterStatuses[result.userId] || {}
  return {
    ...state,
    chapterStatuses: {
      ...state.chapterStatuses,
      [result.userId]: {
        ...userChapters,
        [result.kapitelId]: {
          status: result.status,
          lastStatusChange: result.lastStatusChange,
        },
      },
    },
    isLoading: false,
  }
}

export function rejected(state, pl, error) {
  return {
    ...state,
    isLoading: false,
    ausbildungsPlanError: error && error.message ? error.message : i18n.t('misc_unknown_error'),
  }
}

export async function action(payload) {
  switch (payload.statusChange) {
    case 'Einreichen':
      return handleEinreichen(payload)

    case 'Freigeben':
      return handleFreigeben(payload)

    case 'Ablehnen':
      return handleAblehnen(payload)

    case 'Zurueckziehen':
      return handleZurueckziehen(payload)
  }
}

async function handleFreigeben(payload) {
  try {
    return await Api.freigebenAusbildungsplan(payload.azubiId, payload.chapterId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
async function handleEinreichen(payload) {
  try {
    return await Api.einreichenAusbildungsplan(payload.chapterId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
async function handleAblehnen(payload) {
  try {
    return await Api.ablehnenAusbildungsplan(payload.azubiId, payload.chapterId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
async function handleZurueckziehen(payload) {
  try {
    return await Api.freigabeZurueckziehenAusbildungsplan(payload.azubiId, payload.chapterId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
